export default __webpack_public_path__ + "static/media/eve.0a0f64c6.svg";